import React, { ReactElement, useEffect } from 'react';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import MpkStart from '../../../module/PracovnyKrok/MpkStart';
import SuccessMessages from '../../../module/SuccessMessages';
import { useSecurityContext } from '../../../context/SecurityContext';
import usePracovneKroky
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/component/PracovneKroky/hooks/usePracovneKroky';
import pracovnyKrokAvailable from '../../../function/pracovnyKrokFunctions';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';

const MpkAdminStartPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail();

  const { accessToken } = useSecurityContext();
  const {
    pracovneKrokyRequest: pracovneKroky,
    pracovneKrokyStatus,
  } = usePracovneKroky(type, year, index, accessToken);

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Legislatívne procesy',
          to: routes.procesy.list,
        },
        {
          to: routes.procesy.detail.withParams(type, year, index),
          heading: `${type}/${year}/${index}`,
        },
        {
          to: routes.procesy.admin.mpk.start.withParams(type, year, index, pracovnyKrokId),
          heading: 'Konfigurácia Pripomienkového konania - admin',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading || pracovneKrokyStatus.loading}>
        <SecuredPage
          additionalCheck={!!pracovnyKrokAvailable(pracovneKroky, PracovnyKrokEnum.PRECHOD_MPK)}
          allowForRoles={[UserRoleEnum.SUPERADMIN]}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Konfigurácia Pripomienkového konania - admin"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <MpkStart
                  materialDetail={materialDetail}
                  admin
                />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default MpkAdminStartPage;
